export default __webpack_public_path__ + "static/media/hht1_ani_01.63fca834.png";